import React, {
  useContext,
} from 'react';
import {
  ThemeContext,
} from 'styled-components';
import {
  lighten,
} from 'polished';
import RSelect from 'react-select';
import CreatableSelect from 'react-select/creatable';

type Props = {
  theme?: any,
  styles?: any,
  creatable?: boolean,
};

const Select = ({
  theme,
  styles,
  creatable,
  ...rest
}: Props) => {
  const tm = useContext(ThemeContext);
  const Component = creatable ? CreatableSelect : RSelect;
  const customStyles = {
    option: provided => ({
      ...provided,
      fontSize: '14px',
      lineHeight: '14px',
      cursor: 'pointer',
    }),
    ...styles,
  };

  return (
    <Component
      {...rest}
      theme={initial => ({
        ...initial,
        borderRadius: 0,
        colors: {
          ...initial.colors,
          primary: tm.colors.primary,
          primary25: lighten(0.3, tm.colors.primary),
          primary50: lighten(0.3, tm.colors.primary),
        },
        ...theme,
      })}
      styles={customStyles}
    />
  );
};

Select.defaultProps = {
  creatable: false,
  styles: {},
  theme: {},
};

export default Select;
